import styled from "styled-components";

export const StaffCard = styled("div")<{ $isHovered: boolean }>(
  ({ $isHovered }) => `
  display: flex;
  flex-direction: column;
  background-color: white;
  cursor: pointer;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
  box-shadow: ${$isHovered ? "0 8px 24px rgba(0, 0, 0, 0.12)" : "0 2px 8px rgba(0, 0, 0, 0.06)"};
  transition: all 0.3s ease;
`,
);

export const ImageContainer = styled("div")`
  position: relative;
  height: 192px;
  overflow: hidden;
`;

export const CoverImage = styled("img")<{ $isHovered: boolean }>(
  ({ $isHovered }) => `
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: ${$isHovered ? "scale(1.1)" : "scale(1)"};
  transition: transform 0.5s ease;
`,
);

export const RatingBadge = styled("div")`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  padding-block: 4px;
  padding-inline: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const ContentContainer = styled("div")`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoSection = styled("div")``;

export const PriceSection = styled("div")`
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
